import React from "react";
import VehicleStep from "./booking/VehicleStep";
import DateStep from "./booking/DateStep";
import InsuranceStep from "./booking/InsuranceStep";
import PromoStep from "./booking/PromoStep";
import ContactStep from "./booking/ContactStep";

export default function BookingForm({ state, setState, budget, onSubmit, submitted, sending }) {
  const set = (patch) => setState((s) => ({ ...s, ...patch }));

  return (
    <div className="space-y-5">
      <VehicleStep group={state.group} onSelect={(group) => set({ group })} />
      <DateStep state={state} set={set} />
      <InsuranceStep
        group={state.group}
        insuranceId={state.insuranceId}
        onSelect={(insuranceId) => set({ insuranceId })}
      />
      <PromoStep promoCode={state.promoCode} budget={budget} set={set} />
      <ContactStep
        state={state}
        set={set}
        budget={budget}
        onSubmit={onSubmit}
        submitted={submitted}
        sending={sending}
      />
    </div>
  );
}
